import { useTranslation } from 'react-i18next';

export default function MemberForm({ formData, handleInputChange, handleSubmit }) {
  const { t } = useTranslation();

  return (
    <div>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-light mb-2 text-gray-700">
            {t('form.first_name')}
          </label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            required
            className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm font-light focus:outline-none focus:border-gray-900 rounded-lg transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-light mb-2 text-gray-700">
            {t('form.last_name')}
          </label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            required
            className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm font-light focus:outline-none focus:border-gray-900 rounded-lg transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-light mb-2 text-gray-700">
            {t('form.email')}
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm font-light focus:outline-none focus:border-gray-900 rounded-lg transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-light mb-2 text-gray-700">
            {t('form.phone')}
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
            pattern="^\+\d{1,3}[\s-]?\d{2,}([\s-]?\d+)*$"
            placeholder="+41 79 123 45 67"
            className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm font-light focus:outline-none focus:border-gray-900 rounded-lg transition-colors"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-gray-900 text-white py-3 text-sm font-light tracking-wide rounded-lg hover:bg-gray-800 hover:scale-[1.02] transition-all mt-8"
        >
          {t('form.submit')}
        </button>
      </form>
    </div>
  );
}